import Vue from 'vue'

export default {
  /**
   * 更改左边框缩进状况
   */
  changeCollapse(state) {
    state.isCollapse = !state.isCollapse;
    setTimeout(()=>{
      let myEvent = new Event('resize');
      window.dispatchEvent(myEvent);
    },1)
    
  },
  changeLeftnavnum(state,index) {
    state.adminleftnavnum = index;
  },
  setLanguage(state, language){
    localStorage.setItem('lang', language);
    state.language = language;
    
  },
  setChinaJson(state, chinaJson){
    state.chinaJson = chinaJson;
  },
  setMenuListState(state, menu){
    state.menuListState = menu;
  },
  setAuthOperationState(state, authOper){
    state.authOperationState = authOper;
  },
  setMultiLanguage(state, language){
    let lang = localStorage.getItem('multi_lang');
    state.language = lang;
    
  },
  setRouter(state, route){
    state.route = route.fullPath;
    if (state.route == "/ScreenMonitor1") {
      let multiLanguage = "zh";
      if (localStorage.getItem('multi_lang')) {
        multiLanguage = localStorage.getItem('multi_lang');
      }
      state.language = multiLanguage;
      localStorage.setItem('user_lang', multiLanguage)
    }else{
      let userLanguage = "zh";
      if (localStorage.getItem('lang')) {
        userLanguage = localStorage.getItem('lang');
      }
      state.language = userLanguage;
      localStorage.setItem('user_lang', userLanguage)
    }
  }
}
